import React, { useMemo, useState } from "react";
import { Pencil, FolderInput, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { esTecnico, nombrePropuesto } from "@/lib/nombres";
import { useData } from "@/context/DataContext";
import { buildTodosDocs } from "@/lib/todosDocs";
import { AsignarSheet } from "@/components/documentos/AsignarSheet";
import { RenombrarSheet } from "@/components/documentos/RenombrarSheet";

const Btn = ({ onClick, icon: I, children, testid }) => (
  <button data-testid={testid} onClick={onClick}
    className="inline-flex items-center gap-1.5 min-h-[44px] px-3.5 rounded-xl bg-[#F2EDE4] text-[#2E5645] font-semibold text-sm border border-[#E5DFD5] hover:bg-[#E5DFD5]">
    <I size={15} /> {children}
  </button>
);

// Cambiar nombre y Mover un documento ya clasificado (los justificantes se gestionan desde Gastos).
export const DocAcciones = ({ doc, testid, mover = true }) => {
  const data = useData();
  const [abierto, setAbierto] = useState(null);
  const info = useMemo(() => buildTodosDocs(data).lista.find((x) => x.doc.id === doc.id), [data, doc.id]);
  const [busy, setBusy] = useState(false);
  const propuesto = esTecnico(doc.filename) ? nombrePropuesto(doc) : "";
  const usarPropuesto = async () => {
    setBusy(true);
    try {
      await data.renombrarDocumento(doc.id, propuesto);
      toast.success("Nombre cambiado", { description: propuesto });
    } catch { toast.error("No se pudo cambiar el nombre."); setBusy(false); }
  };
  const esGasto = doc.category === "Gastos" || (data.gastos || []).some((g) => g.documento_id === doc.id);
  return (
    <div className="w-full flex flex-wrap items-center gap-2 mt-2" data-testid={testid}>
      {propuesto && (
        <button data-testid={`${testid}-nombre-propuesto`} onClick={usarPropuesto} disabled={busy}
          className="w-full text-left bg-[#FFFBEB] border border-[#FDE68A] rounded-xl px-3.5 py-2.5 flex items-start gap-2 disabled:opacity-60">
          <Sparkles size={16} className="text-[#B45309] shrink-0 mt-0.5" />
          <span className="text-sm text-[#1C2421]">Nombre poco claro · <strong className="text-[#B45309]">Usar «{propuesto}»</strong></span>
        </button>
      )}
      <Btn testid={`${testid}-renombrar`} icon={Pencil} onClick={() => setAbierto("nombre")}>Cambiar nombre</Btn>
      {mover && (esGasto
        ? <span className="text-sm text-[#6E7A74]" data-testid={`${testid}-gastos`}>Se organiza desde Gastos</span>
        : <Btn testid={`${testid}-mover`} icon={FolderInput} onClick={() => setAbierto("mover")}>Mover</Btn>)}
      {abierto === "nombre" && <RenombrarSheet doc={doc} onClose={() => setAbierto(null)} />}
      {abierto === "mover" && <AsignarSheet doc={doc} actual={info?.rutas.join(" · ")} onClose={() => setAbierto(null)} />}
    </div>
  );
};
